import styled from 'styled-components'
import { tabletBreakpoint, desktopBreakpoint, mobileBreakpoint } from 'react-components'

export const Slide = styled.a`
    opacity: 0.6;
    display: inline-block;
    padding: 0.313rem 0;
    font: ${({ theme }) =>
        `${theme.typography.font.weight.bold} ${theme.typography.font.size.small} / 1rem ${theme.typography.font.family.latoVerdana}`};
    text-decoration: none;
    transition-duration: 0.2s;
    letter-spacing: 0.0125rem;
    :hover {
        text-decoration: underline;
    }
`

export const Title = styled.span`
    margin: 0 0 ${props => props.theme.spacing.medium};
    font: ${({ theme }) =>
        `${theme.typography.font.weight.bold} ${theme.typography.font.size.small} / 1rem ${theme.typography.font.family.latoVerdana}`};
    color: ${props => props.theme.colors.tfwBlack87};
    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        margin: 0 0 1.25rem;
    }
`

export const FooterLinksContainer = styled.ul`
    list-style: none;
    line-height: 1.6rem;
    padding: 0;
`
export const FooterGroupsContainer = styled(FooterLinksContainer)`
    list-style: none;
    line-height: 1.6rem;
    padding: 0;
    margin: 0;
    display: flex;
    justify-content: space-between;

    @media only screen and (max-width: ${tabletBreakpoint.max}px) {
        flex-wrap: wrap;
    }
`
export const FooterGroup = styled.li`
    padding: ${({ theme }) =>
        `${theme.spacing.medium} ${theme.spacing.xSmall} ${theme.spacing.medium} ${theme.spacing.xxxSmall}`};
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    flex-wrap: wrap;

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        flex: 1 1 16.66%;
    }

    @media only screen and (max-width: ${tabletBreakpoint.max}px) {
        flex: 1 1 33.3%;
    }

    @media only screen and (max-width: ${mobileBreakpoint.max}px) {
        flex: 1 1 50%;
    }
`

export const FooterLinkItem = styled.li`
    list-style: none;
    margin: 1rem 0;
`
